/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Vector3, Quaternion } from 'three';
/**
 * bundled transformations (rotation, position, scale)
 */
export class AffineTransform {
    constructor() {
        this.position = new Vector3();
        this.rotation = new Quaternion();
        this.scale = new Vector3();
    }
    static createIdentity() {
        const t = new AffineTransform();
        t.scale.setScalar(1);
        return t;
    }
    toIdentity() {
        this.position.setScalar(0);
        this.rotation.set(0, 0, 0, 1);
        this.scale.setScalar(1);
    }
    fromMatrix(mat4) {
        mat4.decompose(this.position, this.rotation, this.scale);
    }
    toMatrix(mat4) {
        mat4.compose(this.position, this.rotation, this.scale);
    }
    copy(transform) {
        this.position.copy(transform.position);
        this.rotation.copy(transform.rotation);
        this.scale.copy(transform.scale);
    }
    clone() {
        const affine = new AffineTransform();
        affine.copy(this);
        return affine;
    }
    copyFromObject3D(obj) {
        this.position.copy(obj.position);
        this.rotation.copy(obj.quaternion);
        this.scale.copy(obj.scale);
    }
    copyToObject3D(obj) {
        obj.position.copy(this.position);
        obj.quaternion.copy(this.rotation);
        obj.scale.copy(this.scale);
    }
}
//# sourceMappingURL=AffineTransform.js.map